module.exports = __webpack_public_path__ + "9841f3d.ttf";